module.exports = __webpack_public_path__ + "static/media/santa_cruz.8013719f.jpeg";